import Card from "./Card/Card";

import styles from "./CardGrid.module.css";

function CardGrid({ data }) {
	return (
		<div className={styles.cardGrid}>
			{data.map(({ label, value }) => (
				<Card
                    key={`card-${label}`}
					label={label}
					value={value}
				/>
			))}
		</div>
	);
}

export default CardGrid;
